var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('entity-list-table',{attrs:{"title":_vm.title,"data-service":_vm.dataService,"headers":_vm.headers,"create-route-name":_vm.createRouteName,"edit-route-name":_vm.editRouteName,"allow-delete":_vm.allowDelete,"show-status-column":_vm.showStatusColumn,"filter":_vm.filter},scopedSlots:_vm._u([{key:"item.snoType",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getSnoTypeName(item.snoType))+" ")]}},{key:"item.yml",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getFilialYmlFeedLink(item.id, _vm.baseUrl))+" ")]}},{key:"item.connectionDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatConnectionDate(item.connectionDate))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }